import { apiClient } from '_app'
import {
  ApiResponse,
  InboundTripDto,
  InboundTripPAPSSignedForeignShippersDto,
  InboundTripSendToBrokerTransporterDto,
  InboundTripSendToBrokerTransporterSummaryDto,
  VehicleDto
} from 'dtos'
import { InboundTripPAPSDto } from 'dtos'
import { InboundTripImportBranchDto } from 'dtos'
import { InboundTripDriverInformationDto } from 'dtos'
import { InboundTripsParameters } from 'parameters/inboundTripsParameters'
import { InboundTripPAPSParameters } from 'parameters/inboundTripsParameters'
import { InboundTripPAPSVehiclesParameters } from 'parameters/inboundTripsParameters'
import { base64ToArrayBuffer, URIQuery } from 'utils'

export const getInboundTrips = (parameters: InboundTripsParameters) =>
  apiClient.get<ApiResponse<InboundTripDto[]>>('api/inbound-trips' + URIQuery({ ...parameters })).then(({ data }) => data)

export const getInboundTrip = (inboundTripGuid: string) =>
  apiClient.get<ApiResponse<InboundTripDto>>(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}`).then(response => response.data)

export const createInboundTrip = (values: InboundTripDto) =>
  apiClient.post<ApiResponse<InboundTripDto>>('/api/inbound-trips', values).then(response => response.data)

export const updateInboundTrip = (values: InboundTripDto) =>
  apiClient.put<ApiResponse<InboundTripDto>>('/api/inbound-trips', values).then(response => response.data)

export const deleteInboundTrip = (inboundTripGuid: string) =>
  apiClient.delete(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}`).then(response => response.data)

export const lockInboundTrip = (inboundTripGuid: string) =>
  apiClient.put<ApiResponse<InboundTripDto>>(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/lock`).then(response => response.data)

export const unlockInboundTrip = (inboundTripGuid: string) =>
  apiClient.put<ApiResponse<InboundTripDto>>(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/unlock`).then(response => response.data)

export const getInboundTripPAPS = (inboundTripGuid: string, parameters: InboundTripPAPSParameters) =>
  apiClient
    .get<ApiResponse<InboundTripPAPSDto[]>>(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps` + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getInboundTripPAPSGuid = (inboundTripGuid: string, inboundTripPAPSGuid: string) =>
  apiClient
    .get<ApiResponse<InboundTripPAPSDto>>(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}`)
    .then(response => response.data)

export const getInboundTripPAPSId = (inboundTripsId: string, papsId: string) =>
  apiClient.get<ApiResponse<InboundTripPAPSDto>>(`api/inbound-trips/${inboundTripsId}/paps/${papsId}`).then(({ data }) => data)

export const createInboundTripPAPS = (inboundTripGuid: string, values: InboundTripPAPSDto) =>
  apiClient.post<ApiResponse<InboundTripPAPSDto>>(`/api/inbound-trips/${inboundTripGuid}/paps`, values).then(({ data }) => data)

export const updateInboundTripPAPS = (inboundTripGuid: string, values: InboundTripPAPSDto) =>
  apiClient.put<ApiResponse<InboundTripPAPSDto>>(`/api/inbound-trips/${inboundTripGuid}/paps`, values).then(({ data }) => data)

export const deleteInboundTripPAPS = (inboundTripGuid: string, inboundTripPAPSGuid: string) =>
  apiClient.delete(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}`).then(response => response.data)

export const getInboundTripPAPSVehicles = (inboundTripGuid: string, inboundTripPAPSGuid: string, parameters: InboundTripPAPSVehiclesParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>(
      `/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}/vehicles` + URIQuery({ ...parameters })
    )
    .then(response => response.data)

export const addVehiclesToInboundTripPAPS = (inboundTripGuid: string, inboundTripPAPSGuid: string, values: VehicleDto[]) =>
  apiClient
    .post<ApiResponse<InboundTripPAPSDto>>(
      `/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}/vehicles`,
      values
    )
    .then(response => response.data)

export const removeVehiclesFromInboundTripPAPS = (inboundTripGuid: string, inboundTripPAPSGuid: string, values: VehicleDto[]) =>
  apiClient
    .delete<ApiResponse<InboundTripPAPSDto>>(
      `/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}/vehicles`,
      { data: values }
    )
    .then(response => response.data)

export const lockInboundTripPAPS = (inboundTripGuid: string, inboundTripPAPSGuid: string) =>
  apiClient
    .put<ApiResponse<InboundTripPAPSDto>>(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}/lock`)
    .then(response => response.data)

export const unlockInboundTripPAPS = (inboundTripGuid: string, inboundTripPAPSGuid: string) =>
  apiClient
    .put<ApiResponse<InboundTripPAPSDto>>(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}/unlock`)
    .then(response => response.data)

export const getInboundTripImportBranch = (inboundTripGuid: string) =>
  apiClient
    .get<ApiResponse<InboundTripImportBranchDto>>(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/import-branch`)
    .then(response => response.data)

export const updateInboundTripImportBranch = (inboundTripGuid: string, values: InboundTripImportBranchDto) =>
  apiClient.put<ApiResponse<InboundTripImportBranchDto>>(`/api/inbound-trips/${inboundTripGuid}/import-branch`, values).then(response => response.data)

export const getInboundTripDriverInformation = (inboundTripGuid: string) =>
  apiClient
    .get<ApiResponse<InboundTripDriverInformationDto>>(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/driver-information`)
    .then(response => response.data)

export const updateInboundTripDriverinformation = (inboundTripGuid: string, values: InboundTripDriverInformationDto) =>
  apiClient
    .put<ApiResponse<InboundTripDriverInformationDto>>(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/driver-information`, values)
    .then(({ data }) => data)

export const getInboundTripPAPSProForma = (inboundTripGuid: string, inboundTripPAPSGuid: string) =>
  apiClient.get(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}/pro-forma`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'application/pdf' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const getInboundTripPAPSForeignShippers = (inboundTripGuid: string, inboundTripPAPSGuid: string) =>
  apiClient.get(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}/foreign-shippers`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'application/pdf' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const uploadInboundTripPAPSSignedForeignShippers = (
  inboundTripGuid: string,
  inboundTripPAPSGuid: string,
  values: InboundTripPAPSSignedForeignShippersDto
) => {
  const data = new FormData()

  if (values.signedForeignShippersFile) {
    data.append('signedForeignShippersFile', values.signedForeignShippersFile)
  }

  return apiClient<ApiResponse<InboundTripPAPSDto>>({
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'put',
    url: `/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}/signed-foreign-shippers`
  }).then(response => response.data)
}

export const getInboundTripPAPSSignedForeignShippers = (inboundTripGuid: string, inboundTripPAPSGuid: string) =>
  apiClient
    .get(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}/signed-foreign-shippers`)
    .then(response => {
      const buffer = base64ToArrayBuffer(response.data)
      const file = new Blob([buffer], { type: 'image/png' })
      const fileUrl = window.URL.createObjectURL(file)
      const _newTab = window.open(fileUrl)
    })

export const getInboundTripBrokerPdf = (inboundTripGuid: string) =>
  apiClient.get(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/broker-pdf`).then(response => {
    const buffer = base64ToArrayBuffer(response.data)
    const file = new Blob([buffer], { type: 'application/pdf' })
    const fileUrl = window.URL.createObjectURL(file)
    const _newTab = window.open(fileUrl)
  })

export const getInboundTripSendToBrokerTransporterSummary = (inboundTripGuid: string) =>
  apiClient
    .get<ApiResponse<InboundTripSendToBrokerTransporterSummaryDto>>(
      `/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/send-to-broker-transporter-summary`
    )
    .then(response => response.data)

export const sendToBrokerTransporter = (inboundTripGuid: string, values: InboundTripSendToBrokerTransporterDto) =>
  apiClient.post(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/send-to-broker-transporter`, values).then(response => response.data)

export const getInboundTripPAPSAbramsAutoInvoice = (inboundTripGuid: string, inboundTripPAPSGuid: string) =>
  apiClient
    .get(`/api/inbound-trips/${encodeURIComponent(inboundTripGuid)}/paps/${encodeURIComponent(inboundTripPAPSGuid)}/abrams-auto-invoice`, {
      responseType: 'blob'
    })
    .then(response => response.data)
